import API from './API';
import { normalize } from './crud';

// -----------------------------------------------------------------------------
//  SCHEDA CLIENTE — le chiamate della pagina di dettaglio del cliente.
//
//  Il pacchetto valet (entità `Minute`, legata all'AUTO) si propone con le
//  stessa funzione della creazione cliente: `proponiPacchetto` in
//  `nuovoClienteAPI.js`. Al cliente non parte nessuna email: il pacchetto lo
//  accetta Simba. Qui ci sono solo letture e le
//  modifiche di cliente e auto.
//
//  Ogni chiamata passa `skipErrorToast`: il messaggio lo decide la pagina.
//
//  ⚠️ LE COORDINATE NON LE RICALCOLA IL BACKEND. In registrazione il server
//  geolocalizza l'indirizzo; in modifica (`PATCH /customer/:id`) salva i campi
//  così come arrivano. Chi cambia l'indirizzo deve mandare anche `latitude` e
//  `longitude`, altrimenti il planner continua a calcolare le distanze dal
//  punto vecchio.
// -----------------------------------------------------------------------------

const SILENZIOSO = { skipErrorToast: true };

/** Quante prenotazioni mostra la scheda: le più recenti. */
export const LIMITE_PRENOTAZIONI = 50;

/** Il cliente. 404/403 se non è fra i clienti del partner. */
export async function leggiCliente(id) {
  const { data } = await API.get(`/customer/${id}`, SILENZIOSO);
  return data;
}

/** Le auto del cliente, con i pacchetti valet e il partner di ciascuno. */
export async function leggiAuto(customerId) {
  const res = await API.get('/car', {
    ...SILENZIOSO,
    params: {
      filter: `customer.id||$eq||${customerId}`,
      join: ['customer', 'minutes', 'minutes.partner'],
      sort: 'marca,ASC',
    },
  });
  return normalize(res).rows;
}

/**
 * Le prenotazioni del cliente con il partner, dalla più recente.
 *
 * ⚠️ Il join `customer` è OBBLIGATORIO: senza, il filtro `customer.id` non ha
 * la tabella a cui riferirsi e il server risponde 500 («Unknown column
 * 'customer.id'»).
 */
export async function leggiPrenotazioni(customerId) {
  const res = await API.get('/booking', {
    ...SILENZIOSO,
    params: {
      filter: `customer.id||$eq||${customerId}`,
      join: ['customer', 'headquarter', 'car'],
      sort: 'data,DESC',
      limit: LIMITE_PRENOTAZIONI,
    },
  });
  const { rows } = normalize(res);
  return { rows, troncato: rows.length >= LIMITE_PRENOTAZIONI };
}

/** Aggiorna i campi del cliente. Il partner lo verifica il backend. */
export async function aggiornaCliente(id, campi) {
  const { data } = await API.patch(`/customer/${id}`, { id, ...campi }, SILENZIOSO);
  return data;
}

/** Nuova auto del cliente. */
export async function creaAuto(auto) {
  const { data } = await API.post('/car', auto, SILENZIOSO);
  return data;
}

/** Modifica i dati di un'auto (solo i campi dell'auto, niente relazioni). */
export async function aggiornaAuto(id, campi) {
  const { data } = await API.patch(`/car/${id}`, campi, SILENZIOSO);
  return data;
}

export default {
  LIMITE_PRENOTAZIONI,
  leggiCliente,
  leggiAuto,
  leggiPrenotazioni,
  aggiornaCliente,
  creaAuto,
  aggiornaAuto,
};
